import React from "react";
import { Receipt, ArrowRight, TruckIcon, TrendingDown } from "lucide-react";

export default function Summary({ summary, FinalizeAward}) {
    //console.log("Summary Data:", summary); // Debugging line
  return (
    <div className="bg-gray-100 text-[#00000] rounded-xl p-6 shadow-lg overflow-y-auto mb-5">
      <h3 className="flex items-center gap-2 mb-4 text-lg font-semibold">
        <Receipt className="text-blue-400" /> Award Summary
      </h3>

      {/* Totals Section */}
      <div className="space-y-3 text-sm">
        <div className="flex justify-between">
          <span>Items Total</span>
          <span className="font-medium">₹{summary.itemsTotal.toLocaleString()}</span>
        </div>
        <div className="flex justify-between">
          <span>Delivery</span>
          <span className="font-medium">₹{summary.deliveryTotal.toLocaleString()}</span>
        </div>
      </div>

      <hr className="my-4 border-slate-700" />

      {/* Grand Total */}
      <div className="text-3xl font-bold text-green-400 mb-4">
        ₹{summary.grandTotal.toLocaleString()}
      </div>

      {/* Delivery Details (enhanced for Figma match) */}
      {summary.deliveries.length > 0 && (
        <div className="mb-4">
          <h4 className="text-sm font-medium mb-2 flex items-center gap-2">
            <TruckIcon className="text-blue-400" /> Delivery Breakdown
          </h4>
          <div className="space-y-2 text-xs">
            {summary.deliveries.map((d, idx) => (
              <div key={idx} className="bg-gray-200 p-2 rounded">
                <div className="font-medium">{d.supplier}</div>
                <div className="text-[#00000]">
                  {d.vehicle} • {d.distance} km • {d.weight.toFixed(1)} kg • {d.itemCount} items
                </div>
                <div className="text-green-400 font-medium">₹{d.cost.toLocaleString()}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Finalize Button (only if all selected) */}
      { summary.selectedCount > 0 && (
        <button className="mt-6 w-full bg-blue-600 hover:bg-blue-700 py-3 rounded-lg flex items-center justify-center gap-2 transition-colors"
          onClick={FinalizeAward}>
          Finalize Award <ArrowRight />
        </button>
      )}

      {/* Optional: Savings Indicator (added for Figma's emphasis on optimization) */}
      {summary.completionPercentage === 100 && (
        <div className="mt-4 flex items-center gap-2 text-green-400 text-sm">
          <TrendingDown /> Potential Savings: ₹{Math.round(summary.grandTotal * 0.1)} (10% estimate)
        </div>
      )}
    </div>
  );
}
